/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Connected city containing at least one confirmed catalog card.
 * @export
 * @interface AccommodationCatalogCityDto
 */
export interface AccommodationCatalogCityDto {
    /**
     * 
     * @type {string}
     * @memberof AccommodationCatalogCityDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AccommodationCatalogCityDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AccommodationCatalogCityDto
     */
    regionId: string;
    /**
     * 
     * @type {string}
     * @memberof AccommodationCatalogCityDto
     */
    regionName: string;
    /**
     * 
     * @type {string}
     * @memberof AccommodationCatalogCityDto
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof AccommodationCatalogCityDto
     */
    timeZone: string;
    /**
     * 
     * @type {number}
     * @memberof AccommodationCatalogCityDto
     */
    accommodationCount: number;
}

/**
 * Check if a given object implements the AccommodationCatalogCityDto interface.
 */
export function instanceOfAccommodationCatalogCityDto(value: object): value is AccommodationCatalogCityDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('regionId' in value) || value['regionId'] === undefined) return false;
    if (!('regionName' in value) || value['regionName'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('timeZone' in value) || value['timeZone'] === undefined) return false;
    if (!('accommodationCount' in value) || value['accommodationCount'] === undefined) return false;
    return true;
}

export function AccommodationCatalogCityDtoFromJSON(json: any): AccommodationCatalogCityDto {
    return AccommodationCatalogCityDtoFromJSONTyped(json, false);
}

export function AccommodationCatalogCityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccommodationCatalogCityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'regionId': json['regionId'],
        'regionName': json['regionName'],
        'countryCode': json['countryCode'],
        'timeZone': json['timeZone'],
        'accommodationCount': json['accommodationCount'],
    };
}

  export function AccommodationCatalogCityDtoToJSON(json: any): AccommodationCatalogCityDto {
      return AccommodationCatalogCityDtoToJSONTyped(json, false);
  }

  export function AccommodationCatalogCityDtoToJSONTyped(value?: AccommodationCatalogCityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'regionId': value['regionId'],
        'regionName': value['regionName'],
        'countryCode': value['countryCode'],
        'timeZone': value['timeZone'],
        'accommodationCount': value['accommodationCount'],
    };
}

